import Constants from '@/Constants';
import useDebounce from '@/hooks/useDebounce';
import React, { ChangeEvent, ForwardRefRenderFunction, useCallback, useEffect, useImperativeHandle, useState } from 'react';
import './styles.scss';

interface BoxSearchType {
    reset: () => void;
}

interface Props {
    onChange: (value: string) => void;
    placeholder: string;
    delay: number;
    minChars: number;
}

const BaseBoxSearch: ForwardRefRenderFunction<BoxSearchType, Props> = ({ onChange, placeholder, delay = 500, minChars = 2 }: Props, ref) => {
    const [query, setQuery] = useState<string>('');
    const debouncedValue = useDebounce(query, delay);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setQuery(event.target.value);
    };

    const reset = useCallback(() => {
        setQuery('');
    }, []);

    useImperativeHandle(ref, () => ({
        reset,
    }));

    useEffect(() => {
        if (debouncedValue.trim().length > minChars) {
            onChange(debouncedValue);
        }
        if (!debouncedValue) {
            onChange('');
        }
    }, [debouncedValue]);

    return (
        <>
            <div className="search-box form-group inner-addon left-addon">
                <i className="material-icons-outlined align-middle input-icon search-icon">{Constants.icons.SEARCH}</i>
                <input className="form-control" onChange={handleChange} placeholder={placeholder} value={query} />
                {!!query && (
                    <button onClick={reset}>
                        <span className="material-icons-outlined input-icon">clear</span>
                    </button>
                )}
            </div>
        </>
    );
};

export type BoxSearch = BoxSearchType;
export const BoxSearch = React.forwardRef(BaseBoxSearch);
